const actions = {
    TRANSACTION_CHANGE: "TRANSACTION_CHANGE", //*
    TRANSACTION_CHANGE_CONTACT_ID: 'TRANSACTION_CHANGE_CONTACT_ID',
    TRANSACTION_CHANGE_CONTACT2_ID: 'TRANSACTION_CHANGE_CONTACT2_ID',
    TRANSACTION_SET_SHOW_SHIPPING: 'TRANSACTION_SET_SHOW_SHIPPING',
    TRANSACTION_CHANGE_DATE: 'TRANSACTION_CHANGE_DATE',
    TRANSACTION_CHANGE_CURRENCY_CODE: 'TRANSACTION_CHANGE_CURRENCY_CODE',
    TRANSACTION_CHANGE_EXCHANGE_RATE: 'TRANSACTION_CHANGE_EXCHANGE_RATE',
    TRANSACTION_CHANGE_AMOUNT: 'TRANSACTION_CHANGE_AMOUNT',
    TRANSACTION_SET_AMOUNT_DEFINED: 'TRANSACTION_SET_AMOUNT_DEFINED',
    TRANSACTION_CHANGE_TAX_MODE: 'TRANSACTION_CHANGE_TAX_MODE',
    TRANSACTION_SET_PAYMENT_MODE: 'TRANSACTION_SET_PAYMENT_MODE',
    TRANSACTION_SET_TERM_ID: 'TRANSACTION_SET_TERM_ID',
    TRANSACTION_SET_DUE_DATE: 'TRANSACTION_SET_DUE_DATE',
    TRANSACTION_SET_SEND_EMAIL: 'TRANSACTION_SET_SEND_EMAIL',
    TRANSACTION_SET_EMAILS: 'TRANSACTION_SET_EMAILS',
    TRANSACTION_SET_MESSAGE: 'TRANSACTION_SET_MESSAGE',
    TRANSACTION_CHANGE_EMAIL_DATA: 'TRANSACTION_CHANGE_EMAIL_DATA', /////
    TRANSACTION_CHANGE_LINK_ITEMS: "TRANSACTION_CHANGE_LINK_ITEMS",
    TRANSACTION_CHANGE_LINK_ITEM: "TRANSACTION_CHANGE_LINK_ITEM",
    TRANSACTION_SET_LINK_ITEM_KEYS: "TRANSACTION_SET_LINK_ITEM_KEYS",
    TRANSACTION_SET_FORM_SUMMARY_DATA: "TRANSACTION_SET_FORM_SUMMARY_DATA",
    TRANSACTION_SET_LINK_SUMMARY_DATA: "TRANSACTION_SET_LINK_SUMMARY_DATA",
    TRANSACTION_SET_BANK_SUMMARY_DATA: "TRANSACTION_SET_BANK_SUMMARY_DATA",
    TRANSACTION_SET_JOURNAL_SUMMARY_DATA: "TRANSACTION_CHANGE_JSET_SUMMARY_DATA",
    TRANSACTION_SET_ROUNDING_ON: 'TRANSACTION_SET_ROUNDING_ON',
    TRANSACTION_CREATE_REQUEST: 'TRANSACTION_CREATE_REQUEST',
    TRANSACTION_CREATE_SUCCESS: 'TRANSACTION_CREATE_SUCCESS',
    TRANSACTION_CREATE_ERROR: 'TRANSACTION_CREATE_ERROR',
    TRANSACTION_READ_ALL_REQUEST: 'TRANSACTION_READ_ALL_REQUEST',
    TRANSACTION_READ_ALL_SUCCESS: 'TRANSACTION_READ_ALL_SUCCESS',
    TRANSACTION_READ_ALL_ERROR: 'TRANSACTION_READ_ALL_ERROR',
    TRANSACTION_READ_REQUEST: 'TRANSACTION_READ_REQUEST',
    TRANSACTION_READ_SUCCESS: 'TRANSACTION_READ_SUCCESS',
    TRANSACTION_READ_ERROR: 'TRANSACTION_READ_ERROR',
    TRANSACTION_DUPLICATE_REQUEST: 'TRANSACTION_DUPLICATE_REQUEST',
    TRANSACTION_DUPLICATE_SUCCESS: 'TRANSACTION_DUPLICATE_SUCCESS',
    TRANSACTION_DUPLICATE_ERROR: 'TRANSACTION_DUPLICATE_ERROR',
    TRANSACTION_TRANSFER_REQUEST: 'TRANSACTION_TRANSFER_REQUEST',
    TRANSACTION_TRANSFER_SUCCESS: 'TRANSACTION_TRANSFER_SUCCESS',
    TRANSACTION_TRANSFER_ERROR: 'TRANSACTION_TRANSFER_ERROR',
    TRANSACTION_COPY_REQUEST: 'TRANSACTION_COPY_REQUEST',
    TRANSACTION_COPY_SUCCESS: 'TRANSACTION_COPY_SUCCESS',
    TRANSACTION_COPY_ERROR: 'TRANSACTION_COPY_ERROR',
    TRANSACTION_PAY_REQUEST: 'TRANSACTION_PAY_REQUEST',
    TRANSACTION_PAY_SUCCESS: 'TRANSACTION_PAY_SUCCESS',
    TRANSACTION_PAY_ERROR: 'TRANSACTION_PAY_ERROR',
    TRANSACTION_UPDATE_REQUEST: 'TRANSACTION_UPDATE_REQUEST',
    TRANSACTION_UPDATE_SUCCESS: 'TRANSACTION_UPDATE_SUCCESS',
    TRANSACTION_UPDATE_ERROR: 'TRANSACTION_UPDATE_ERROR',
    TRANSACTION_UPDATE_STATUS_REQUEST: 'TRANSACTION_UPDATE_STATUS_REQUEST',
    TRANSACTION_UPDATE_STATUS_SUCCESS: 'TRANSACTION_UPDATE_STATUS_SUCCESS',
    TRANSACTION_UPDATE_STATUS_ERROR: 'TRANSACTION_UPDATE_STATUS_ERROR',
    TRANSACTION_DELETE_REQUEST: 'TRANSACTION_DELETE_REQUEST',
    TRANSACTION_DELETE_SUCCESS: 'TRANSACTION_DELETE_SUCCESS',
    TRANSACTION_DELETE_ERROR: 'TRANSACTION_DELETE_ERROR',
    TRANSACTION_READ_JOURNAL_ENTRIES_REQUEST: 'TRANSACTION_READ_JOURNAL_ENTRIES_REQUEST',
    TRANSACTION_READ_JOURNAL_ENTRIES_SUCCESS: 'TRANSACTION_READ_JOURNAL_ENTRIES_SUCCESS',
    TRANSACTION_READ_JOURNAL_ENTRIES_ERROR: 'TRANSACTION_READ_JOURNAL_ENTRIES_ERROR',
    TRANSACTION_READ_PROFITABILITY_REQUEST: 'TRANSACTION_READ_PROFITABILITY_REQUEST',
    TRANSACTION_READ_PROFITABILITY_SUCCESS: 'TRANSACTION_READ_PROFITABILITY_SUCCESS',
    TRANSACTION_READ_PROFITABILITY_ERROR: 'TRANSACTION_READ_PROFITABILITY_ERROR',
    TRANSACTION_READ_OUTSTANDING_REQUEST: 'TRANSACTION_READ_OUTSTANDING_REQUEST',
    TRANSACTION_READ_OUTSTANDING_SUCCESS: 'TRANSACTION_READ_OUTSTANDING_SUCCESS',
    TRANSACTION_READ_OUTSTANDING_ERROR: 'TRANSACTION_READ_OUTSTANDING_ERROR',
    TRANSACTION_READ_PENDING_INVOICE_REQUEST: 'TRANSACTION_READ_PENDING_INVOICE_REQUEST',
    TRANSACTION_READ_PENDING_INVOICE_SUCCESS: 'TRANSACTION_READ_PENDING_INVOICE_SUCCESS',
    TRANSACTION_READ_PENDING_INVOICE_ERROR: 'TRANSACTION_READ_PENDING_INVOICE_ERROR',
    TRANSACTION_SEND_EMAIL_REQUEST: 'TRANSACTION_SEND_EMAIL_REQUEST',
    TRANSACTION_SEND_EMAIL_SUCCESS: 'TRANSACTION_SEND_EMAIL_SUCCESS',
    TRANSACTION_SEND_EMAIL_ERROR: 'TRANSACTION_SEND_EMAIL_ERROR',
    TRANSACTION_BULK_VIEW_PDF_REQUEST: 'TRANSACTION_BULK_VIEW_PDF_REQUEST',
    TRANSACTION_BULK_VIEW_PDF_SUCCESS: 'TRANSACTION_BULK_VIEW_PDF_SUCCESS',
    TRANSACTION_BULK_VIEW_PDF_ERROR: 'TRANSACTION_BULK_VIEW_PDF_ERROR',
    TRANSACTION_SEND_BULK_EMAIL_REQUEST: 'TRANSACTION_SEND_BULK_EMAIL_REQUEST',
    TRANSACTION_SEND_BULK_EMAIL_SUCCESS: 'TRANSACTION_SEND_BULK_EMAIL_SUCCESS',
    TRANSACTION_SEND_BULK_EMAIL_ERROR: 'TRANSACTION_SEND_BULK_EMAIL_ERROR',
    TRANSACTION_BULK_READY_REQUEST: 'TRANSACTION_BULK_READY_REQUEST',
    TRANSACTION_BULK_READY_SUCCESS: 'TRANSACTION_BULK_READY_SUCCESS',
    TRANSACTION_BULK_READY_ERROR: 'TRANSACTION_BULK_READY_ERROR',
    TRANSACTION_BULK_PENDING_APPROVAL_REQUEST: 'TRANSACTION_BULK_PENDING_APPROVAL_REQUEST',
    TRANSACTION_BULK_PENDING_APPROVAL_SUCCESS: 'TRANSACTION_BULK_PENDING_APPROVAL_SUCCESS',
    TRANSACTION_BULK_PENDING_APPROVAL_ERROR: 'TRANSACTION_BULK_PENDING_APPROVAL_ERROR',
    TRANSACTION_BULK_VOID_REQUEST: 'TRANSACTION_BULK_VOID_REQUEST',
    TRANSACTION_BULK_VOID_SUCCESS: 'TRANSACTION_BULK_VOID_SUCCESS',
    TRANSACTION_BULK_VOID_ERROR: 'TRANSACTION_BULK_VOID_ERROR',
    TRANSACTION_BULK_UNVOID_REQUEST: 'TRANSACTION_BULK_UNVOID_REQUEST',
    TRANSACTION_BULK_UNVOID_SUCCESS: 'TRANSACTION_BULK_UNVOID_SUCCESS',
    TRANSACTION_BULK_UNVOID_ERROR: 'TRANSACTION_BULK_UNVOID_ERROR',
    TRANSACTION_BULK_DELETE_REQUEST: 'TRANSACTION_BULK_DELETE_REQUEST',
    TRANSACTION_BULK_DELETE_SUCCESS: 'TRANSACTION_BULK_DELETE_SUCCESS',
    TRANSACTION_BULK_DELETE_ERROR: 'TRANSACTION_BULK_DELETE_ERROR',
    TRANSACTION_ADD_FILE: 'TRANSACTION_ADD_FILE',
    TRANSACTION_READ_FILE_REQUEST: 'TRANSACTION_READ_FILE_REQUEST',
    TRANSACTION_READ_FILE_SUCCESS: 'TRANSACTION_READ_FILE_SUCCESS',
    TRANSACTION_READ_FILE_ERROR: 'TRANSACTION_READ_FILE_ERROR',
    TRANSACTION_SET_FILE: 'TRANSACTION_SET_FILE',
    TRANSACTION_SET_FILES: 'TRANSACTION_SET_FILES',
    TRANSACTION_REMOVE_FILE: 'TRANSACTION_REMOVE_FILE',
    TRANSACTION_RESET_STATE: 'TRANSACTION_RESET_STATE',

    TRANSACTION_CHANGE_STATUS: 'TRANSACTION_CHANGE_STATUS',
    TRANSACTION_CHANGE_MYINVOIS_ACTION: 'TRANSACTION_CHANGE_MYINVOIS_ACTION',

    TRANSACTION_TABLE_ON_ROW_CLICK: 'TRANSACTION_TABLE_ON_ROW_CLICK',
    TRANSACTION_TABLE_AFTER_ROW_CLICK: 'TRANSACTION_TABLE_AFTER_ROW_CLICK',
    TRANSACTION_TABLE_LIST_MENU_CLICK: 'TRANSACTION_TABLE_LIST_MENU_CLICK',

    TRANSACTION_TRANSFER_OPEN_ITEM_MODAL: 'TRANSACTION_TRANSFER_OPEN_ITEM_MODAL',
    TRANSACTION_TRANSFER_CLOSE_ITEM_MODAL: 'TRANSACTION_TRANSFER_CLOSE_ITEM_MODAL',
    TRANSACTION_TRANSFER_OPEN_SELECT_MODAL: 'TRANSACTION_TRANSFER_OPEN_SELECT_MODAL',
    TRANSACTION_TRANSFER_CLOSE_SELECT_MODAL: 'TRANSACTION_TRANSFER_CLOSE_SELECT_MODAL',
    TRANSACTION_TRANSFER_SET_DATA: 'TRANSACTION_TRANSFER_SET_DATA',
    TRANSACTION_TRANSFER_REMOVE_DATA: 'TRANSACTION_TRANSFER_REMOVE_DATA',

    TRANSACTION_TRANSFER_READ_ALL_IDS_REQUEST: 'TRANSACTION_TRANSFER_READ_ALL_IDS_REQUEST',
    TRANSACTION_TRANSFER_READ_ALL_IDS_SUCCESS: 'TRANSACTION_TRANSFER_READ_ALL_IDS_SUCCESS',
    TRANSACTION_TRANSFER_READ_ALL_IDS_ERROR: 'TRANSACTION_TRANSFER_READ_ALL_IDS_ERROR',

    // used for Invoice/Summary Table and Bill/Summary Table
    TRANSACTION_SET_APPLIED_LINKED_IDS: 'TRANSACTION_SET_APPLIED_LINKED_IDS',
    TRANSACTION_SET_APPLIED_LINK_ITEMS: 'TRANSACTION_SET_APPLIED_LINK_ITEMS',

    TRANSACTION_ADD_TO_APPLIED_LINKED_IDS: 'TRANSACTION_ADD_TO_APPLIED_LINKED_IDS',
    TRANSACTION_REMOVE_APPLIED_LINKED_ID: 'TRANSACTION_REMOVE_APPLIED_LINKED_ID',
    TRANSACTION_CLEAR_APPLIED_LINKED_IDS: 'TRANSACTION_CLEAR_APPLIED_LINKED_IDS',

    TRANSACTION_READ_AUDITS_REQUEST: 'TRANSACTION_READ_AUDITS_REQUEST',
    TRANSACTION_READ_AUDITS_SUCCESS: 'TRANSACTION_READ_AUDITS_SUCCESS',
    TRANSACTION_READ_AUDITS_ERROR: 'TRANSACTION_READ_AUDITS_ERROR',

    TRANSACTION_CREATE_INTEREST_INVOICES_REQUEST: 'TRANSACTION_CREATE_INTEREST_INVOICES_REQUEST',
    TRANSACTION_CREATE_INTEREST_INVOICES_SUCCESS: 'TRANSACTION_CREATE_INTEREST_INVOICES_SUCCESS',
    TRANSACTION_CREATE_INTEREST_INVOICES_ERROR: 'TRANSACTION_CREATE_INTEREST_INVOICES_ERROR',

    TRANSACTION_OPEN_EMAIL_TRACKER_REQUEST: 'TRANSACTION_OPEN_EMAIL_TRACKER_REQUEST',
    TRANSACTION_OPEN_EMAIL_TRACKER_SUCCESS: 'TRANSACTION_OPEN_EMAIL_TRACKER_SUCCESS',
    TRANSACTION_OPEN_EMAIL_TRACKER_ERROR: 'TRANSACTION_OPEN_EMAIL_TRACKER_ERROR',
    TRANSACTION_CLOSE_EMAIL_TRACKER: 'TRANSACTION_CLOSE_EMAIL_TRACKER',

    TRANSACTION_READ_TRANSFER_TO_TRANSACTIONS_REQUEST: 'TRANSACTION_READ_TRANSFER_TO_INFO_REQUEST',
    TRANSACTION_READ_TRANSFER_TO_TRANSACTIONS_SUCCESS: 'TRANSACTION_READ_TRANSFER_TO_INFO_SUCCESS',
    TRANSACTION_READ_TRANSFER_TO_TRANSACTIONS_ERROR: 'TRANSACTION_READ_TRANSFER_TO_INFO_ERROR',

    TRANSACTION_RECALCULATE: 'TRANSACTION_RECALCULATE',

    TRANSACTION_INIT_REQUEST: 'TRANSACTION_INIT_REQUEST',
    TRANSACTION_INIT_SUCCESS: 'TRANSACTION_INIT_SUCCESS',
    TRANSACTION_INIT_ERROR: 'TRANSACTION_INIT_ERROR',

    TRANSACTION_GET_PDF_PREVIEW_REQUEST: 'TRANSACTION_GET_PDF_PREVIEW_REQUEST',
    TRANSACTION_GET_PDF_PREVIEW_SUCCESS: 'TRANSACTION_GET_PDF_PREVIEW_SUCCESS',
    TRANSACTION_GET_PDF_PREVIEW_ERROR: 'TRANSACTION_GET_PDF_PREVIEW_ERROR',

    TRANSACTION_SET_AUTOSAVE_MODAL: 'TRANSACTION_SET_AUTOSAVE_MODAL',

    TRANSACTION_RESTORE_AUTOSAVE_DATA_REQUEST: 'TRANSACTION_RESTORE_AUTOSAVE_DATA_REQUEST',
    TRANSACTION_RESTORE_AUTOSAVE_DATA_SUCCESS: 'TRANSACTION_RESTORE_AUTOSAVE_DATA_SUCCESS',
    TRANSACTION_RESTORE_AUTOSAVE_DATA_ERROR: 'TRANSACTION_RESTORE_AUTOSAVE_DATA_ERROR',

    transactionInit: (
        transactionType,
        matchParams = {},
        form = {},
        restoreForm = false,
        autosaveModalRef = null,
    ) => ({
        type: actions.TRANSACTION_INIT_REQUEST,
        transactionType,
        matchParams,
        form,
        restoreForm,
        autosaveModalRef,
    }),
    transactionInitSuccess: (transaction, transactionType) => ({
        type: actions.TRANSACTION_INIT_SUCCESS,
        transaction,
        transactionType,
    }),

    transactionChange: initData => ({
        type: actions.TRANSACTION_CHANGE,
        initData,
    }),
    changeContactId: contactId => ({
        type: actions.TRANSACTION_CHANGE_CONTACT_ID,
        contactId,
    }),
    changeContact2Id: contact2Id => ({
        // to support forms with multiple contacts eg: contra
        type: actions.TRANSACTION_CHANGE_CONTACT2_ID,
        contact2Id,
    }),
    setShowShipping: showShipping => ({
        type: actions.TRANSACTION_SET_SHOW_SHIPPING,
        showShipping,
    }),
    changeDate: date => ({
        type: actions.TRANSACTION_CHANGE_DATE,
        date,
    }),
    changeCurrencyCode: currencyCode => ({
        type: actions.TRANSACTION_CHANGE_CURRENCY_CODE,
        currencyCode,
    }),
    changeExchangeRate: exchangeRate => ({
        type: actions.TRANSACTION_CHANGE_EXCHANGE_RATE,
        exchangeRate,
    }),
    changeAmount: amount => ({
        type: actions.TRANSACTION_CHANGE_AMOUNT,
        amount,
    }),
    setAmountDefined: value => ({
        type: actions.TRANSACTION_SET_AMOUNT_DEFINED,
        value,
    }),
    changeTaxMode: taxMode => ({
        type: actions.TRANSACTION_CHANGE_TAX_MODE,
        taxMode,
    }),
    setPaymentMode: paymentMode => ({
        type: actions.TRANSACTION_SET_PAYMENT_MODE,
        paymentMode,
    }),
    setTermId: termId => ({
        type: actions.TRANSACTION_SET_TERM_ID,
        termId,
    }),
    setDueDate: dueDate => ({
        type: actions.TRANSACTION_SET_DUE_DATE,
        dueDate,
    }),
    setSendEmail: sendEmail => ({
        type: actions.TRANSACTION_SET_SEND_EMAIL,
        sendEmail,
    }),
    setEmails: emails => ({
        type: actions.TRANSACTION_SET_EMAILS,
        emails,
    }),
    setMessage: message => ({
        type: actions.TRANSACTION_SET_MESSAGE,
        message,
    }),
    changeEmailData: emailData => ({ /////
        type: actions.TRANSACTION_CHANGE_EMAIL_DATA,
        emailData,
    }),
    changeLinkItems: (linkItems, tableName = null) => ({
        type: actions.TRANSACTION_CHANGE_LINK_ITEMS,
        linkItems,
        tableName,
    }),
    changeLinkItem: (linkItem, tableName = null) => ({
        type: actions.TRANSACTION_CHANGE_LINK_ITEM,
        linkItem,
        tableName,
    }),
    setLinkItemKeys: (linkItemKeys, tableName = null) => ({
        type: actions.TRANSACTION_SET_LINK_ITEM_KEYS,
        linkItemKeys,
        tableName,
    }),
    setFormSummaryData: formSummaryData => ({
        type: actions.TRANSACTION_SET_FORM_SUMMARY_DATA,
        formSummaryData,
    }),
    setLinkSummaryData: (linkSummaryData, tableName = null) => ({
        type: actions.TRANSACTION_SET_LINK_SUMMARY_DATA,
        linkSummaryData,
        tableName,
    }),
    setBankSummaryData: bankSummaryData => ({
        type: actions.TRANSACTION_SET_BANK_SUMMARY_DATA,
        bankSummaryData,
    }),
    setJournalSummaryData: journalSummaryData => ({
        type: actions.TRANSACTION_SET_JOURNAL_SUMMARY_DATA,
        journalSummaryData,
    }),
    setRounding: checked => ({
        type: actions.TRANSACTION_SET_ROUNDING_ON,
        checked,
    }),
    transactionCreate: (transactionType, request, isRecreate = false) => ({
        type: actions.TRANSACTION_CREATE_REQUEST,
        transactionType,
        request,
        isRecreate, // boolean: to support recreate invoice from audit trail
    }),
    transactionReadAll: (transactionType, request) => ({
        type: actions.TRANSACTION_READ_ALL_REQUEST,
        transactionType,
        request,
    }),

    // Read Transaction
    // - No more Copy, Duplicate, Transfer functionality
    transactionRead: (transactionType, id, request = {}) => ({
        type: actions.TRANSACTION_READ_REQUEST,
        transactionType,
        id,
        request,
    }),

    transactionUpdate: (transactionType, id, request) => ({
        type: actions.TRANSACTION_UPDATE_REQUEST,
        transactionType,
        id,
        request,
    }),
    transactionUpdateStatus: (transactionType, id, request) => ({
        type: actions.TRANSACTION_UPDATE_STATUS_REQUEST,
        transactionType,
        id,
        request,
    }),
    transactionDelete: (transactionType, id) => ({
        type: actions.TRANSACTION_DELETE_REQUEST,
        transactionType,
        id,
    }),
    readJournalEntries: (transactionType, id) => ({
        type: actions.TRANSACTION_READ_JOURNAL_ENTRIES_REQUEST,
        transactionType,
        id,
    }),
    readProfitability: (transactionType, id) => ({
        type: actions.TRANSACTION_READ_PROFITABILITY_REQUEST,
        transactionType,
        id,
    }),
    transactionReadOutstanding: (transactionType, request, withTableName = false) => ({
        type: actions.TRANSACTION_READ_OUTSTANDING_REQUEST,
        transactionType,
        request,
        withTableName, // boolean: used when there are multiple linkItems table (eg: contra)
    }),
    transactionReadPendingInvoices: request => ({
        type: actions.TRANSACTION_READ_PENDING_INVOICE_REQUEST,
        request,
    }),
    transactionSendEmail: (transactionType, id, request) => ({
        type: actions.TRANSACTION_SEND_EMAIL_REQUEST,
        transactionType,
        id,
        request,
    }),
    transactionBulkViewPDF: (transactionType, request) => ({
        type: actions.TRANSACTION_BULK_VIEW_PDF_REQUEST,
        transactionType, // "sales" / "purchases" / "banking" / "journal_entry"
        request, // { "transaction_ids": Int[], "form_design_id": Int }
    }),
    transactionSendBulkEmail: (transactionType, request) => ({
        type: actions.TRANSACTION_SEND_BULK_EMAIL_REQUEST,
        transactionType,
        request,
    }),
    transactionBulkReady: (transactionType, request) => ({
        type: actions.TRANSACTION_BULK_READY_REQUEST,
        transactionType,
        request,
        status: 'ready',
    }),
    transactionBulkPendingApproval: (transactionType, request) => ({
        type: actions.TRANSACTION_BULK_PENDING_APPROVAL_REQUEST,
        transactionType,
        request,
        status: 'pending_approval',
    }),
    transactionBulkVoid: (transactionType, request) => ({
        type: actions.TRANSACTION_BULK_VOID_REQUEST,
        transactionType,
        request,
        status: 'void',
    }),
    transactionBulkDelete: (transactionType, request) => ({
        type: actions.TRANSACTION_BULK_DELETE_REQUEST,
        transactionType,
        request,
    }),
    addFile: file => ({
        type: actions.TRANSACTION_ADD_FILE,
        file,
    }),
    setFile: file => ({
        type: actions.TRANSACTION_SET_FILE,
        file,
    }),
    setFiles: files => ({
        type: actions.TRANSACTION_SET_FILES,
        files,
    }),
    removeFile: fileId => ({
        type: actions.TRANSACTION_REMOVE_FILE,
        fileId,
    }),
    transactionResetState: () => ({
        type: actions.TRANSACTION_RESET_STATE,
    }),

    transactionChangeStatus: status => ({
        type: actions.TRANSACTION_CHANGE_STATUS,
        status,
    }),
    transactionChangeMyinvoisAction: myinvoisAction => ({
        type: actions.TRANSACTION_CHANGE_MYINVOIS_ACTION,
        myinvoisAction,
    }),

    transactionTransferOpenItemModal: (originType, transactionType) => ({
        type: actions.TRANSACTION_TRANSFER_OPEN_ITEM_MODAL,
        originType,
        transactionType,
    }),
    transactionTransferCloseItemModal: () => ({
        type: actions.TRANSACTION_TRANSFER_CLOSE_ITEM_MODAL,
    }),
    transactionTransferOpenSelectModal: () => ({
        type: actions.TRANSACTION_TRANSFER_OPEN_SELECT_MODAL,
    }),
    transactionTransferCloseSelectModal: selectedIds => ({
        type: actions.TRANSACTION_TRANSFER_CLOSE_SELECT_MODAL,
        selectedIds,
    }),
    transactionTransferReadAll: () => ({
        type: actions.TRANSACTION_TRANSFER_READ_ALL_IDS_REQUEST,
    }),
    transactionTransferSetData: (idx, data) => ({
        type: actions.TRANSACTION_TRANSFER_SET_DATA,
        idx,
        data,
    }),
    transactionTransferRemoveData: idx => ({
        type: actions.TRANSACTION_TRANSFER_REMOVE_DATA,
        idx,
    }),

    // Audit Logs History
    transactionReadAudits: (id, pageQueryString) => ({
        type: actions.TRANSACTION_READ_AUDITS_REQUEST,
        id,
        pageQueryString,
    }),
    transactionSetAppliedLinkedIds: ids => ({
        type: actions.TRANSACTION_SET_APPLIED_LINKED_IDS,
        ids,
    }),
    setAppliedLinkItems: items => ({
        type: actions.TRANSACTION_SET_APPLIED_LINK_ITEMS,
        items,
    }),
    transactionAddToAppliedLinkedIds: id => ({
        type: actions.TRANSACTION_ADD_TO_APPLIED_LINKED_IDS,
        id,
    }),
    transactionRemoveAppliedLinkedId: id => ({
        type: actions.TRANSACTION_REMOVE_APPLIED_LINKED_ID,
        id,
    }),
    transactionClearAppliedLinkedIds: () => ({
        type: actions.TRANSACTION_CLEAR_APPLIED_LINKED_IDS,
    }),

    // trigger transaction table onRow click
    transactionTableOnRowClick: (id, history, transactionTableOpenNewTab) => ({
        type: actions.TRANSACTION_TABLE_ON_ROW_CLICK,
        id,
        history,
        transactionTableOpenNewTab,
    }),

    transactionTableAfterRowClick: () => ({
        type: actions.TRANSACTION_TABLE_AFTER_ROW_CLICK,
    }),

    // key of the action selected, eg 'void' will have 'void' key
    transactionTableListMenuClick: key => ({
        type: actions.TRANSACTION_TABLE_LIST_MENU_CLICK,
        key,
    }),

    // Interest invoices
    createInterestInvoices: requestData => ({
        type: actions.TRANSACTION_CREATE_INTEREST_INVOICES_REQUEST,
        requestData,
    }),

    // Email Tracker Modal
    openEmailTracker: (transactionType, id) => ({
        type: actions.TRANSACTION_OPEN_EMAIL_TRACKER_REQUEST,
        transactionType,
        id,
    }),

    closeEmailTracker: () => ({
        type: actions.TRANSACTION_CLOSE_EMAIL_TRACKER,
    }),

    readTransferToTransactionsRequest: itemId => ({
        type: actions.TRANSACTION_READ_TRANSFER_TO_TRANSACTIONS_REQUEST,
        itemId,
    }),

    getPdfPreview: (transactionType, request) => ({
        type: actions.TRANSACTION_GET_PDF_PREVIEW_REQUEST,
        transactionType,
        request,
    }),

    recalculate: () => ({
        type: actions.TRANSACTION_RECALCULATE,
    }),
};
export default actions;
